// extracted by mini-css-extract-plugin
export default {"container":"Products_container__uMIWj","ul":"Products_ul__pETLv","p":"Products_p__wawCg"};